const name = 'BackgroundParallaxZoom';
const properties = {
    hideOnStart: false,
    requestFullScreenHeight: true,
    groups: ['animation', 'background', 'legacy'],
    schema: {},
};
/**
 * TODO: THIS IS A TEMP STUB FOR THE TRANSITION TO "Smooth Scroll" PROJECT https://jira.wixpress.com/browse/BOLT-2314
 */
function animate(kit, params) {
    const sequence = kit.sequence(params);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=backgroundParallaxZoom.js.map